import { useTranslation } from 'react-i18next';
import { useTagsQuery } from '@platform/state/api';
import type { ITagSelectProps } from './ITagSelectProps';

/** «Усі теги» + теги робочого простору (прототип v4: вибір 32px, мін. 180px, один тег); вибір тегу фільтрує список (`tags:has`). */
export function TagSelect({ ws, value, onChange }: ITagSelectProps) {
  const { t } = useTranslation();
  const { data: tags = [] } = useTagsQuery(ws);
  return (
    <select className="lv-select lv-tags" value={value[0] ?? ''} aria-label={t('listbar.tagFilter')} title={t('listbar.tagFilter')}
      onChange={(e) => onChange(e.target.value ? [e.target.value] : [])}>
      <option value="">{t('listbar.allTags')}</option>
      {tags.map((tag) => <option key={tag.id} value={tag.name}>{tag.name}</option>)}
    </select>
  );
}
